import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        title1: {
            align: "left",
            letterSpacing: 0,
            marginLeft: 0,
            display: "flex",
            fontSize: '1.7142857142857142em',
            fontWeight: 'bold',
        },
        title2: {
            align: "left",
            fontSize: '0.8571428571428571em',
            fontWeight: 400,
        },
        formField: {
            align: "center",
            marginTop: 8,
            fontSize: '0.8571428571428571em',
            marginBottom: 16,
            width: '98%',
            
           
        },
        textField1: {
            align: "left",
            width: "100%",
            height: '100%',
            fontSize: '0.8571428571428571em',
           
        },
        
        adornedStart: {
            height: '100%',
            background: '#E0E0E0',
        },
        input: {
            background: '#FFF',
            marginLeft: 10,
            paddingLeft: 10,
            fontSize: '0.8571428571428571em',
        },
        errorText: {
            marginTop: 6,
            color: 'red',
            
            fontSize: '0.7857142857142857em',
        },
        errorIcon: {
            verticalAlign: 'middle',
            fontSize: '0.7857142857142857em',
            marginRight: 4,
        },
        TextFieldRoot: {
            '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                    borderColor: 'red',
                },
            },
        },
        noStyle: {
            
        },
        
    }),
);